// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"302":"2467edd2","392":"2383cd18","834":"acd5523a","882":"27fed151"}[chunkId] + ".chunk.js";
};